module.exports = __webpack_public_path__ + "static/media/office-2.e01940f8.jpg";